export const GTMPushEvent = (data) => {
  // eslint-disable-next-line
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};
